<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup MST_013
 * @created at      :   2026/01/23
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST013 from '@/views/popupSearch/PopupMST013/store';
import helpers from '@/utils/helpers';

var PopupMST013Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST013')) {
            store.registerModule('PopupMST013', PopupMST013);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST013', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST013', ['searchBankBranchInfo']),
        ...mapMutations('PopupMST013', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.bank_cd !== undefined) {
                    this.data.bank_cd = this.initData.bank_cd;
                }
                if (this.initData.bank_name !== undefined) {
                    this.data.bank_name = this.initData.bank_name;
                }
                if (this.initData.bank_branch_cd !== undefined) {
                    this.data.bank_branch_cd = this.initData.bank_branch_cd;
                }
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchBankBranchInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchBankBranchInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.bank_branch_cd);
            this.$emit('onReferValueName', item.bank_branch_name);
            this.$emit('close');
        }
    }
};
export default PopupMST013Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
